<div data-cy="confirm-with-text-input-dialog">
  <h1 mat-dialog-title>
    {{ data.title }}
  </h1>
  <div
    mat-dialog-content
    class="dialog-content">
    <p>{{ data.message }}</p>
    <mat-form-field class="full-width">
      <mat-label>{{ data.inputLabel }}</mat-label>
      <input
        matInput
        [formControl]="textInputControl"
        data-cy="confirm-text-input"
        autocomplete="off" />
      <mat-error *ngIf="textInputControl.hasError('required')">
        {{ ("required" | i18n) || "Required" }}
      </mat-error>
      <mat-error *ngIf="textInputControl.hasError('pattern')">
        {{ ("inputDoesNotMatch" | i18n) || "Input does not match" }}
      </mat-error>
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button
      mat-button
      (click)="cancel()"
      data-cy="dialog-cancel">
      {{ data.cancelText || ("cancel" | i18n) || "Cancel" | uppercase }}
    </button>
    <button
      mat-button
      color="warn"
      (click)="confirm()"
      [disabled]="!textInputControl.valid"
      data-cy="dialog-confirm">
      {{ data.confirmText || ("confirm" | i18n) || "Confirm" | uppercase }}
    </button>
  </div>
</div>
